import apiClient from './client';
import { ProviderActivationOutcomeDto, ProviderActivationStartRequestDto, ProviderActivationStateDto } from 'interfaces/invoicing';
import { invoicingRequest } from './invoicingErrors';

type CompanyId = number | string;

interface ProviderActivationService {
  get(companyId: CompanyId): Promise<ProviderActivationStateDto>;
  start(companyId: CompanyId, data: ProviderActivationStartRequestDto): Promise<ProviderActivationOutcomeDto>;
  resume(companyId: CompanyId): Promise<ProviderActivationOutcomeDto>;
}

const endpoints = {
  activation: (companyId: CompanyId) => `/tenant/companies/${companyId}/invoicing/fiscal-profile/provider-activation`,
  resume: (companyId: CompanyId) => `/tenant/companies/${companyId}/invoicing/fiscal-profile/provider-activation/resume`,
};

/**
 * Onboarding one company with the fiscal provider. `get` is what the settings page polls while a
 * sign-up is in flight: the account's API key reaches the backend by webhook, so the status changes
 * some time after the customer comes back from the provider — never poll the provider itself.
 */
export const providerActivationService: ProviderActivationService = {
  get: companyId => invoicingRequest(() => apiClient.get(endpoints.activation(companyId))),
  start: (companyId, data) => invoicingRequest(() => apiClient.post(endpoints.activation(companyId), data)),
  resume: companyId => invoicingRequest(() => apiClient.post(endpoints.resume(companyId))),
};
